import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  CardBody,
  ModalFooter,
  Card,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { connect } from 'react-redux';
import {
  API_Documents,
  postAPI_Create_QuestionSet,
  putAPI_Update_QuestionSet,
  API_OpenAI_Assistant,
  API_Publish_Assistant,
  gAPI_DynmicApisList,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import Validation from '../../../../../../components/Validation';
import moment from 'moment';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import UploadJson from '../../json';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import Logs from './Logs';
import json from '../../json';
const fromPropertyId = process.env.REACT_APP_COPILOT_PROPERTY_ID;
const fromGroupId = process.env.REACT_APP_COPILOT_GROUP_ID;

function QuestionSetForm({
  /** Globle property id from redux */
  propertyId,
  CancelQuestionSet,
  loadResponse,
  setName,
  setId,
  updateSet,
  type,
  setDescription,
  setInstructions,
  locale,
  aiModel,
  aiAssistantId,
  userName,
  actions,
  seriesFlowInvokeApi,
  seriesTrainingData,
  seriesConversationFlow,
  setIsGroupVisible,
  dynmaicQuestionSet,
  aiReasoningEfforts,
  aiVerbosity
}) {
  const [showLogs, setShowLogs] = useState(false);
  const [imageIndex, setImageIndex] = useState(-1);
  const [jsonVisible, setjsonVisible] = useState(false);
  const [documentList, setDocumentList] = useState([]);
  const [selectedDocumentList, setSelectedDocumentList] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [visible, setVisible] = useState(false);
  const [editJson, setEditJson] = useState(false);
  const [currentJson, setCurrentJson] = useState('');
  const [buttonTextInput, setButtonTextInput] = useState(
    setName == undefined ? '' : setName
  );
  const [pubishConversation, setPublishConversation] = useState(
    seriesConversationFlow || false
  );
  const [seriesType, setSeriesType] = useState(
    type == undefined ? 'ConversationFlow' : type
  );
  const [seriesDescription, setSeriesDescription] = useState(
    setDescription == undefined ? '' : setDescription
  );
  const [seriresInstruction, setSeriresInstructions] = useState(
    setInstructions == undefined ? '' : setInstructions
  );
  const [openAiModel, setOpenAiModel] = useState(
    aiModel !== undefined && aiModel !== null ? aiModel : ''
  );
  const [openAiAssistantId, setOpenAiAssistantId] = useState(
    aiAssistantId !== undefined && aiAssistantId !== null && aiAssistantId
  );
  const [seriesIsGroupVisible, setSeriesIsGroupVisible] = useState(
    setIsGroupVisible == undefined ? false : setIsGroupVisible
  );
  // const [openAiReasoningEfforts, setOpenAiReasoningEfforts] = useState(
  //   aiReasoningEfforts !== undefined && aiReasoningEfforts !== null ? aiReasoningEfforts : 'minimal'
  // );
  const [openAiReasoningEfforts, setOpenAiReasoningEfforts] = useState('minimal');
  const [openAiVerbosity, setOpenAiVerbosity] = useState(
    aiVerbosity !== undefined && aiVerbosity !== null ? aiVerbosity : 'medium'
  );
  const [flowTrainingData, setFlowTrainingData] = useState(
    seriesTrainingData || {
      isEnabled: false,
      includeDocuments: false,
      includeFAQ: false,
      includeKnowledgeData: false,
      documents: [],
    }
  );

  const [flowInvokeApi, setFlowInvokeApi] = useState(
    seriesFlowInvokeApi || {
      isEnabled: false,
      json: [],
    }
  );

  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    PropertyId: propertyId === '-1' ? null : propertyId,
    Name: '',
    Description: '',
    IsGroupVisible: false,
    Status: 'Active',
    Creator: userName,
    Type: 'ConversationFlow',
    languageCode: locale,
  });
  const [browseApiId, setBrowseApiId] = useState('');
  const [isbrowseApi, setIsbrowseApi] = useState(false);
  const [templateApiList, setTemplateApiList] = useState([]);

  const handleToggleLogs = () => setShowLogs(!showLogs);

  const toggle = () => {
    setVisible(!visible);
  };

  const toggleJson = () => {
    setEditJson(!editJson);
  };

  const toggleJsonUploader = (index) => {
    setImageIndex(index);
    setjsonVisible(!jsonVisible);
  };
  console.log('12', dynmaicQuestionSet)
  useEffect(() => {
    if (dynmaicQuestionSet !== undefined && dynmaicQuestionSet !== null) {
      setButtonTextInput(dynmaicQuestionSet.name);
      setSeriesType(dynmaicQuestionSet.type);
      setSeriresInstructions(dynmaicQuestionSet.instructions);
      setSeriesIsGroupVisible(dynmaicQuestionSet.isGroupVisible);
      setOpenAiModel(dynmaicQuestionSet.openAiModel);
      setOpenAiReasoningEfforts('minimal');
      setOpenAiVerbosity(dynmaicQuestionSet.openAiVerbosity);
      setFlowTrainingData(dynmaicQuestionSet.flowTrainingData);
      setFlowInvokeApi(dynmaicQuestionSet.flowInvokeApi);
    }
  }, [dynmaicQuestionSet]);
  const selectedJson = (image) => {
    const newItems = [...flowInvokeApi.json];
    newItems.push(image.status);
    setFlowInvokeApi({
      ...flowInvokeApi,
      json: newItems,
    });
    toggleJsonUploader();
  };

  const JsonUploaderButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={jsonVisible}
                toggle={toggleJsonUploader}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={toggleJsonUploader}>
                  Upload New Json
                </ModalHeader>
                <ModalBody>
                  <UploadJson
                    selectedJson={selectedJson}
                    togglegallery={toggleJsonUploader}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const deleteJson = (index) => {
    let obj = [...flowInvokeApi.json];
    obj = obj.filter((f, i) => i !== index);
    setFlowInvokeApi({ ...flowInvokeApi, json: obj });
  };

  const handleAddApiJson = () => {
    let lst = [...flowInvokeApi.json];
    lst.push('');
    setFlowInvokeApi({ ...flowInvokeApi, json: lst });
    setCurrentJson({
      text: '',
      id: lst.length - 1,
    });
    toggleJson();
  };

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${API_Documents}?groupId=${getGroupID()}&propertyId=${propertyId}&sortType=`,
    }).then((res) => {
      if (res.data !== undefined && res.data.length > 0) {
        let lst = [];
        res.data.map((m) => lst.push({ id: m.id, name: m.title }));
        let selectedList = [];
        if (
          flowTrainingData.documents !== undefined &&
          flowTrainingData.documents !== null &&
          flowTrainingData.documents.length > 0
        ) {
          flowTrainingData.documents.map((m) => {
            if (res.data.filter((f) => f.id === m).length > 0)
              selectedList.push({
                key: res.data.filter((f) => f.id === m)[0].id,
                label: res.data.filter((f) => f.id === m)[0].title,
                value: res.data.filter((f) => f.id === m)[0].id,
              });
          });
        }
        setDocumentList(lst);
        setSelectedDocumentList(selectedList);
      }
    });
  }, [propertyId]);

  useEffect(() => {
    console.log('290', openAiModel
      , openAiReasoningEfforts, openAiVerbosity
    )
    setPostData({
      ...postData,
      Name: buttonTextInput,
      Type: seriesType,
      Description: seriesDescription,
      IsGroupVisible: seriesIsGroupVisible,
      OpenAiModel: openAiModel,
      OpenAiReasoningEfforts: 'minimal',
      OpenAiVerbosity: openAiVerbosity,
      Instructions: seriresInstruction,
      FlowTrainingData: flowTrainingData,
      FlowInvokeApi: flowInvokeApi,
      pubishConversationFlow: pubishConversation,
    });
  }, [
    buttonTextInput,
    seriesType,
    seriesDescription,
    openAiModel,
    seriresInstruction,
    flowTrainingData,
    flowInvokeApi,
    pubishConversation,
    openAiReasoningEfforts,
    openAiVerbosity
  ]);

  const handleTrainingData = (e) => {
    console.log(e.target.name, e.target.checked);
    setFlowTrainingData({
      ...flowTrainingData,
      [e.target.name]: e.target.checked,
    });
  };

  const handlePublishConversation = (e) => {
    setPublishConversation(e.target.checked);
  };
  const handleInvokeApiFlow = (e, index) => {
    let obj = flowInvokeApi;
    obj.json[index] = e;
    setFlowInvokeApi(obj);
    setCurrentJson({
      text: e,
      id: index,
    });
  };

  const handleDocuments = (options) => {
    setSelectedDocumentList(options);
    if (options.filter((f) => f.value === 'All').length === 0) {
      setFlowTrainingData({
        ...flowTrainingData,
        documents: options.map((i) => i.value),
      });
    } else {
      setFlowTrainingData({
        ...flowTrainingData,
        documents: options.filter((f) => f.id !== 'All').map((i) => i.id),
      });
    }
  };
  const handleCaptionChange = (e) => {
    setButtonTextInput(e.target.value);
  };
  const handleOpenAiModel = (e) => {
    setOpenAiModel(e.target.value);
  };
  // const handleOpenAiReasoningEfforts = (value) => {
  //   setOpenAiReasoningEfforts(value);
  // };

  const handleOpenAiVerbosity = (value) => {
    setOpenAiVerbosity(value);
  };
  const handleTypeChange = (e) => {
    setSeriesType(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setSeriesDescription(e.target.value);
  };
  const handleCheckChange = (e) => {
    setSeriesIsGroupVisible(e.target.checked);
  };

  const handlePublish = () => {
    NotificationManager.success(
      '',
      'We are processing your request. The changes are Live in under a minute',
      3000,
      null,
      null,
      'success'
    );
    AxiosAPI({
      method: 'post',
      url: `${API_Publish_Assistant}`,
      data: { id: setId },
    }).then((res) => {
      try {
        let functions = [];
        if (
          flowInvokeApi !== undefined &&
          flowInvokeApi.isEnabled !== undefined &&
          flowInvokeApi.isEnabled === true
        ) {
          if (
            flowInvokeApi.json !== undefined &&
            flowInvokeApi.json.length > 0
          ) {
            flowInvokeApi.json.map((m) => {
              if (m !== '') functions.push(JSON.parse(m));
            });
          }
        }
        let body = {
          instructions: seriresInstruction,
          model: openAiModel,
          name: buttonTextInput,
          id: setId,
          function: functions.map((f) => f),
          vector_id: res.data.status !== null ? res.data.status : '',
          content: {
            instructions: setInstructions,
            model: aiModel,
            name: setName,
            flowInvokeApi: flowInvokeApi,
            flowTrainingData: flowTrainingData,
          },
          action:
            'Last Published By ' + userName + ' at ' + moment().format('LLL'),
        };
        if (
          res.data.status !== undefined &&
          res.data.status !== null &&
          res.data.status !== ''
        )
          body.vector_id = res.data.status !== null && res.data.status;
        if (
          openAiAssistantId !== undefined &&
          openAiAssistantId !== null &&
          openAiAssistantId !== ''
        ) {
          AxiosAPI({
            method: 'put',
            url: `${API_OpenAI_Assistant}/update/${openAiAssistantId}`,
            data: body,
          }).then((res) => {
            CancelQuestionSet();
            loadResponse();
          });
        } else {
          AxiosAPI({
            method: 'post',
            url: `${API_OpenAI_Assistant}/create`,
            data: body,
          }).then((res) => {
            CancelQuestionSet();
            loadResponse();
          });
        }
      } catch (error) {
        console.error(error);
      }
    });
  };

  const handleInstructionChange = (e) => {
    setSeriresInstructions(e.target.value);
  };

  const handleSave = async () => {
    postData.OpenAiReasoningEfforts = 'minimal';
    postData.IsGroupVisible = seriesIsGroupVisible;
    console.log('29008', postData, setId)
    if (setId === undefined) {
      try {
        return await AxiosAPI({
          method: 'post',
          url: `${postAPI_Create_QuestionSet}`,
          data: postData,
        }).then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            setTimeout(() => {
              CancelQuestionSet();
              loadResponse();
            }, 1000);
          }
        });
      } catch (error) {
        console.error(error);
      }
    } else {
      let data = {
        Name: buttonTextInput,
        Type: seriesType,
        Instructions: seriresInstruction,
        Description: seriesDescription,
        IsGroupVisible: seriesIsGroupVisible,
        flowTrainingData: flowTrainingData,
        flowInvokeApi: flowInvokeApi,
        Status: 'Active',
        Updater: 'Dashboard',
        Creator: userName,
        publishConversationFlow: pubishConversation,
        OpenAiModel: openAiModel,
        OpenAiReasoningEfforts: 'minimal',
        OpenAiVerbosity: openAiVerbosity,
      };
      try {
        return await AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_QuestionSet}/${setId}`,
          data: data,
        }).then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            updateSet(buttonTextInput, seriesDescription);
          }
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  const addCurrentJson = (val, index) => {
    setCurrentJson({
      text: val,
      id: index,
    });
    toggleJson();
  };

  const handleApiSwitch = (value) => {
    setFlowInvokeApi({ ...flowInvokeApi, isEnabled: value });
  };

  const handleTrainingSwitch = (value) => {
    setFlowTrainingData({ ...flowTrainingData, isEnabled: value });
  };

  const LoadBrowseApiList = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_DynmicApisList}/?propertyId=${fromPropertyId}&groupId=${fromGroupId}`,
    }).then((res) => {
      setTemplateApiList(res.data);
    });
  };
  const handleCancel = () => {
    CancelQuestionSet();
  };

  const checkedFlow = (e) => {
    if (e.target.checked) {
      setBrowseApiId(e.target.value);
    }
    if (!e.target.checked) {
      setBrowseApiId('');
    }
  };
  const toggleBrowswApi = () => {
    setIsbrowseApi(true);
    LoadBrowseApiList();
  };

  const AddBrowseAPI = () => {
    var data = templateApiList.filter((l) => l.id == browseApiId);
    if (data.length > 0) {
      var flowlist = [...flowInvokeApi.json];
      flowlist.push(data[0].apiCode);
      setFlowInvokeApi({ ...flowInvokeApi, json: flowlist });
      setIsbrowseApi(false);
    }
  };
  return (
    <div>
      <Row>
        <Colxx xxs="12" className="mb-3">
          <Label>Title</Label>
          <Input
            type="text"
            value={buttonTextInput}
            onChange={handleCaptionChange}
            placeholder="Enter the name"
            onMouseDown={(e) => e.stopPropagation()}
          />
        </Colxx>
        {setId === undefined && (
          <Colxx xxs="12" className="mb-3">
            <Label>Flow Type</Label>
            <Input
              type="select"
              value={seriesType}
              name="type"
              onChange={handleTypeChange}
            >
              {/* <option value="Products">Products</option>
              <option value="Rooms">Rooms</option>
              <option value="Addons">Addons</option>
              <option value="Promos">Promos</option>
              <option value="Property">Property</option> */}
              <option value="ConversationFlow">Static Conversation Flow</option>
              <option value="DynamicConversationFlow">
                Dynamic Conversation Flow
              </option>
            </Input>
          </Colxx>
        )}
        {seriesType === 'ConversationFlow' && (
          <Colxx xxs="12" className="mb-3">
            <Label>    <IntlMessages id='pages.description' /></Label>
            <Input
              type="textarea"
              value={seriesDescription}
              onChange={handleDescriptionChange}
              placeholder="Enter the short description"
            ></Input>
          </Colxx>
        )}
        {seriesType === 'DynamicConversationFlow' && (
          <Colxx xxs="12" className="mb-3">
            <Label>System Message</Label>
            <Input
              type="textarea"
              value={seriresInstruction}
              onChange={handleInstructionChange}
              placeholder="Enter the instruction"
              style={{ height: '200px', fontSize: '14px' }}
            ></Input>
          </Colxx>
        )}
        {seriesType === 'DynamicConversationFlow' && (
          <Colxx xxs="12" className="mb-3">
            <Label>AI Model</Label>
            <Input
              type="select"
              value={openAiModel}
              name="type"
              onChange={handleOpenAiModel}
            >
              <option value="">Choose AI Model</option>
              <option value="gpt-3.5-turbo">GPT 3.5 Turbo</option>
              <option value="gpt-4o">GPT 4o</option>
              <option value="gpt-4o-mini">GPT 4o Mini</option>
              <option value="gpt-5-mini">GPT 5 Mini</option>
            </Input>
          </Colxx>
        )}
        {seriesType === 'DynamicConversationFlow' && openAiModel === 'gpt-5-mini' &&
          <Fragment>
            {/* <Colxx xxs="12" className="mb-3">
              <h7>Reasoning Efforts</h7>
              <Input
                type="select"
                name="reasoningEfforts"
                value={openAiReasoningEfforts}
                onChange={(e) => handleOpenAiReasoningEfforts(e.target.value)}
                className="mt-1"
              >
                <option value="">Select</option>
                <option value="minimal">Minimal</option>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </Input>
            </Colxx> */}
            <Colxx xxs="12" className="mb-3">
              <h7>Verbosity</h7>
              <Input
                type="select"
                name="verbosity"
                value={openAiVerbosity}
                onChange={(e) => handleOpenAiVerbosity(e.target.value)}
                className="mt-1"
              >
                <option value="">Select</option>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </Input>
            </Colxx>
          </Fragment>
        }
        {seriesType === 'DynamicConversationFlow' && (
          <Fragment>
            <Colxx xxs="12" className="mb-3">
              <div className="d-flex">
                <Switch
                  id="Tooltip-Switch"
                  className="agentswitch custom-switch-primary custom-switch-small"
                  checked={flowTrainingData.isEnabled}
                  onChange={handleTrainingSwitch}
                />
                <span className="ml-2">Include Training Data</span>
              </div>
            </Colxx>
            {/*  {flowTrainingData.isEnabled === true &&
              <Row className='ml-4'>
                <Colxx sm={12} className="mb-3">
                  <CustomInput
                    type="checkbox"
                    name="includeFAQ"
                    id="includeFAQ"
                    checked={flowTrainingData.includeFAQ === true ? true : false}
                    onChange={(e) => handleTrainingData(e)}
                    label="Include FAQ"
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <CustomInput
                    type="checkbox"
                    id="includeKnowledgeData"
                    name="includeKnowledgeData"
                    checked={flowTrainingData.includeKnowledgeData === true ? true : false}
                    onChange={(e) => handleTrainingData(e)}
                    label="Include Knowledge Hub Data"
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <CustomInput
                    type="checkbox"
                    id="includeDocuments"
                    name="includeDocuments"
                    checked={flowTrainingData.includeDocuments === true ? true : false}
                    onChange={(e) => handleTrainingData(e)}
                    label="Include Documents"
                  />
                </Colxx>
                {(flowTrainingData.includeDocuments === true && documentList !== undefined
                  && documentList.length > 0) &&
                  <Colxx sm={12} className="mb-3">
                    <Label>Documents</Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      options={documentList.length > 0 && documentList
                        .map((x, i) => {
                          return { label: x.name, value: x.id, key: i };
                        })
                      }
                      value={selectedDocumentList}
                      onChange={(val) => {
                        handleDocuments(val);
                      }}
                    />
                  </Colxx>
                }
              </Row>} */}
            <Colxx xxs="12" className="mb-3">
              <div className="d-flex">
                <Switch
                  id="Tooltip-Switch"
                  className="agentswitch custom-switch-primary custom-switch-small"
                  checked={flowInvokeApi.isEnabled}
                  onChange={handleApiSwitch}
                />
                <span className="ml-2">Include API’s</span>
              </div>
            </Colxx>
            <Colxx xxs="12" className="mb-3">
              {flowInvokeApi.isEnabled === true && (
                <Row className="ml-4">
                  <Colxx xxs="12" className="mb-1">
                    {flowInvokeApi.json !== undefined &&
                      flowInvokeApi.json.length > 0 &&
                      flowInvokeApi.json.map((m, index) => (
                        <Fragment>
                          <Row>
                            <Colxx md="10" className="mb-2">
                              <Input type="text" value={m} disabled></Input>
                            </Colxx>
                            <div className="mb-2">
                              <FontAwesomeIcon
                                icon={faEdit}
                                color="#90caf9"
                                cursor="pointer"
                                onClick={() => addCurrentJson(m, index)}
                              />
                              <b> | </b>
                              <FontAwesomeIcon
                                icon={faTrashAlt}
                                style={{ color: 'var(--theme-color-1)' }}
                                cursor="pointer"
                                onClick={() => deleteJson(index)}
                              />
                            </div>
                          </Row>
                        </Fragment>
                      ))}
                  </Colxx>
                  <Colxx xxs="12" className="mb-3">
                    <Button
                      outline
                      color="primary"
                      size="xs"
                      onClick={handleAddApiJson}
                    >
                      + Add API
                    </Button>

                    <Button
                      className="ml-3"
                      outline
                      color="secondary"
                      size="xs"
                      onClick={toggleBrowswApi}
                    >
                      + Browse API Library
                    </Button>
                  </Colxx>
                </Row>
              )}
            </Colxx>
          </Fragment>
        )}

        {seriesType === 'DynamicConversationFlow' && (
          <Colxx xxs="12" className="mb-3">
            {setId !== undefined &&
              openAiAssistantId !== undefined &&
              openAiAssistantId !== null &&
              openAiAssistantId !== '' && (
                <div style={{ display: 'flex' }}>
                  <Label>
                    <b>Assistant Id:</b> {openAiAssistantId}
                  </Label>
                  <div
                    style={{ cursor: 'pointer', marginLeft: 5, color: 'grey' }}
                    onClick={() => {
                      navigator.clipboard.writeText(openAiAssistantId);
                    }}
                  >
                    {' '}
                    <i className="iconsminds-file-copy"></i>
                  </div>
                </div>
              )}
          </Colxx>
        )}

        {seriesType === 'ConversationFlow' && (
          <Colxx sm={12} className="mb-3">
            <CustomInput
              type="checkbox"
              name="pubishConversation"
              id="pubishConversation"
              checked={pubishConversation}
              onChange={(e) => handlePublishConversation(e)}
              label="Include this flow for auto-triggering if there is a strong match
               found between the customer's question and the description of this conversational flow."
            />
          </Colxx>
        )}

        <Colxx xxs="12" className="mb-3">
          <CustomInput
            type="checkbox"
            id={`checkbox-isgroupvisible`}
            name={`checkbox-isgroupvisible`}
            checked={seriesIsGroupVisible}
            onChange={handleCheckChange}
            label={'Make this Conversation Flow visible across the group'}
          />
        </Colxx>

        {/* {actions !== undefined && actions !== null && actions.length > 0 && (
          <Colxx xxs="12" className="mb-3">
            <b>
              {actions[0].action}{' '}
              {actions.length > 1 && (
                <a
                  href="#"
                  style={{ textDecoration: 'underline' }}
                  onClick={() => toggle()}
                >
                  (View Change log)
                </a>
              )}
            </b>
          </Colxx>
        )} */}
        {seriesType === 'DynamicConversationFlow' && setId !== undefined && (
          <Colxx xxs="12" className="mb-3">
            <b>
              <a
                href="#"
                style={{ textDecoration: 'underline' }}
                onClick={() => handleToggleLogs()}
              >
                <IntlMessages id='dashboards.changelog' />
              </a>
            </b>
          </Colxx>
        )}
      </Row>
      <Row>
        <Colxx xxs="12">
          <div style={{ marginTop: ' 5px', marginBottom: '5px' }}>
            {/* {setId !== undefined &&
              seriesType === 'DynamicConversationFlow' && (
                <Button
                  color="primary"
                  className="add-button"
                  onClick={handlePublish}
                  outline
                >
                  Publish
                </Button>
              )} */}

            <Button
              color="light"
              className="add-button float-right ml-2"
              size="xs"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              color="secondary"
              className="add-button float-right"
              size="xs"
              onClick={handleSave}
            >
              {seriesType === 'ConversationFlow' ? 'Save' : 'Save'}
            </Button>
            <b> </b>
          </div>
        </Colxx>
      </Row>
      {JsonUploaderButton()}
      {showLogs && (
        <Logs
          visible={showLogs}
          label={'Dynamic Conversation F;ow'}
          toggle={handleToggleLogs}
          id={setId}
        ></Logs>
      )}
      <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '600px' }}>
        <ModalHeader toggle={toggle}>Question Set Logs</ModalHeader>
        <ModalBody>
          <Row className="logs" style={{ height: 'auto', maxHeight: '480px' }}>
            {actions !== undefined &&
              actions !== null &&
              actions.length > 0 &&
              actions.map((m) => (
                <Colxx xxs="12">
                  <Card
                    className="d-flex mb-3"
                    key={`faqItem`}
                    style={{ borderRadius: '25px' }}
                  >
                    <CardBody>
                      <Row className="mb-3">
                        <Colxx xxs="12" className="mb-2">
                          {m.action}
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              ))}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Back
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={editJson}
        toggle={toggleJson}
        style={{ maxWidth: '800px' }}
      >
        <ModalHeader toggle={toggleJson}>
          <h6>API Definition</h6>
          <p className="mt-1">
            Define the API specifications and invoke it through the
            instructions.
            <b>
              <a
                href="https://help.myma.ai/en/articles/9768124-conversation-flows"
                style={{ textDecoration: 'underline' }}
                target="_blank"
              >
                View Examples
              </a>
            </b>
            .
          </p>
        </ModalHeader>
        <ModalBody>
          <Row className="logs" style={{ maxHeight: '450px' }}>
            <Colxx xxs="12">
              <Input
                name="ticketMessage"
                onChange={(e) =>
                  handleInvokeApiFlow(e.target.value, currentJson?.id)
                }
                type="textarea"
                style={{ height: '500px' }}
                value={currentJson?.text}
              />
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" className="add-button" onClick={toggleJson}>
            Done
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isbrowseApi}
        toggle={() => setIsbrowseApi(false)}
        style={{ maxWidth: '800px' }}
      >
        <ModalBody>
          <Row className="logs" style={{ maxHeight: '450px' }}>
            <Colxx md="12">
              {templateApiList &&
                templateApiList.length > 0 &&
                templateApiList.map((k, i) => (
                  <Row className="mb-3">
                    <Colxx md={8}>
                      <h5>{k.apiName}</h5>
                      <span>
                        <i>{k.applicability}</i>
                      </span>
                      <br />
                      <span>{k.description}</span>
                      {browseApiId}
                    </Colxx>
                    <Colxx md={4}>
                      <CustomInput
                        key={k.id}
                        type="radio"
                        id={i}
                        value={k.id}
                        checked={k.id == browseApiId ? true : false}
                        onChange={(e) => checkedFlow(e)}
                      />
                    </Colxx>
                  </Row>
                ))}
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter
          style={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Button color="secondary" onClick={() => setIsbrowseApi(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => AddBrowseAPI()}>
            + Add API
          </Button>
        </ModalFooter>
      </Modal>

      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, userName } = settings;
  return {
    propertyId,
    locale,
    userName,
  };
};

export default injectIntl(connect(mapStateToProps)(QuestionSetForm));
